<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="http://spacelocation.co.uk">Space Location</a>
          </li>
          <li>
            <a href="http://spacelocation.co.uk/#about"> About Us </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a
          href="http://spacelocation.co.uk"
          target="_blank"
        >Space Location</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
